import BusinessEnquiriesTemplate from '~templates/business-enquiries'
export default BusinessEnquiriesTemplate
